import { render, staticRenderFns } from "./SizeSelect.vue?vue&type=template&id=23ad7b38&scoped=true&"
import script from "./SizeSelect.vue?vue&type=script&lang=js&"
export * from "./SizeSelect.vue?vue&type=script&lang=js&"
import style0 from "./SizeSelect.vue?vue&type=style&index=0&id=23ad7b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad7b38",
  null
  
)

export default component.exports